import React from 'react'
import { Switch, Route } from 'react-router-dom'
import slug from 'constants/slug'
import LanguageLocaleList from './language-locale-list'
import LanguageLocaleCreate from './language-locale-create'
import LanguageLocaleEdit from './language-locale-edit'

export default props => (
  <Switch>
    <Route
      exact
      path={slug.languageLocale.list}
      render={matchProps => <LanguageLocaleList {...matchProps} {...props} />}
    />
    <Route
      path={slug.languageLocale.create}
      render={matchProps => <LanguageLocaleCreate {...matchProps} {...props} />}
    />
    <Route path={slug.languageLocale.edit} component={LanguageLocaleEdit} />
  </Switch>
)



// WEBPACK FOOTER //
// ./src/containers/language-locale/index.js